/** Verified Chrome Web Store listing URL. */
export const EASY_LOVER_CHROME_WEB_STORE_URL: string | null =
  "https://chromewebstore.google.com/detail/jkjkabncpkldgimklbcajknkcgehkgkn";
